import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { ImmunizationsQuestionnaireItem } from './questionnaire'

export const IMMUNIZATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B]:
    QuestionnaireAnswerType.GROUP,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B_HEP_B]:
    QuestionnaireAnswerType.STRING,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B_DATE]:
    QuestionnaireAnswerType.DATE,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL]:
    QuestionnaireAnswerType.GROUP,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL_MENINGOCOCCAL]:
    QuestionnaireAnswerType.STRING,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL_DATE]:
    QuestionnaireAnswerType.DATE,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19]:
    QuestionnaireAnswerType.GROUP,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19_COVID_19]:
    QuestionnaireAnswerType.STRING,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19_DATE]:
    QuestionnaireAnswerType.DATE,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP]:
    QuestionnaireAnswerType.GROUP,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP_DTAP]:
    QuestionnaireAnswerType.STRING,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP_DATE]:
    QuestionnaireAnswerType.DATE,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV]:
    QuestionnaireAnswerType.GROUP,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV_HPV]:
    QuestionnaireAnswerType.STRING,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV_DATE]:
    QuestionnaireAnswerType.DATE,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_NOTES]:
    QuestionnaireAnswerType.STRING,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV]:
    QuestionnaireAnswerType.GROUP,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV_RSV]:
    QuestionnaireAnswerType.STRING,
  [ImmunizationsQuestionnaireItem.MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV_DATE]:
    QuestionnaireAnswerType.DATE
}
